import React from "react";
import { Col, Container, Row } from "react-bootstrap";

function ManageClub() {
        return (
        <Container>
            <Row>
                <Col xl={8} md={10} xs={12} className="mx-auto">
                    <div className="py-3">
                        <h1 className="font-weight-light text-center mb-4">Work in progress</h1>
                    </div>
                </Col>
            </Row>
        </Container>
    )
}

export default ManageClub;